import type { AttributeValueExpression } from '../../types';

export enum TireSide {
    front = 'front',
    back = 'back',
}

export const tireCommonFilters = [
    {
        field: 'PIM_ATT_ERP_MANUFACTURER',
    },
    {
        field: 'PIM_ATT_APPLICATION_RANGE',
    },
    {
        field: 'PIM_ATT_LOAD_INDEX',
    },
    {
        field: 'PIM_ATT_SPEEDINDEX',
    },
];

export const tirePairFilters = [
    {
        field: 'PIM_ATT_TIRE_WIDTH_MOTO',
    },
    {
        field: 'PIM_ATT_TIRE_HIGHT_MOTO',
    },
    {
        field: 'PIM_ATT_DIAMETER',
    },
    {
        field: 'PIM_ATT_MATCHCODE',
    },
];

export const frontAttribute: AttributeValueExpression = {
    type: 'includes',
    name: 'PIM_ATT_TIRE_TYPE',
    values: ['4533', '4535'],
};

export const backAttribute: AttributeValueExpression = {
    type: 'includes',
    name: 'PIM_ATT_TIRE_TYPE',
    values: ['4534', '4535'],
};

export const allTireFilters = [
    ...tireCommonFilters
        .filter(filter => filter.field !== 'PIM_ATT_ERP_MANUFACTURER')
        .map(filter => filter.field),
    ...tirePairFilters.map(filter => filter.field),
];

export const tireFiltersIgnoreList = [...allTireFilters];

export type FilterSingleValue = Record<string, string | undefined>;
export type FilterMultiValue = Record<string, string[]>;
